import {
  Flex,
  IconArrowOpenDownLine,
  IconArrowOpenUpLine,
  IconButton,
  IconTrashLine,
  Text,
  TextInput,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import CustomRTE from "../CustomTextArea/CustomRTE";

const TemplateQuestionCard = ({
  question,
  index,
  lastQuestion,
  setQuestions,
}) => {
  const { t } = useTranslation();
  const defaultHelperText = useRef(question.helper_text);

  function moveSectionUp() {
    setQuestions((prevQuestions) =>
      prevQuestions.map((prevQuestion, i) =>
        i === index - 1
          ? question
          : i === index
            ? prevQuestions[index - 1]
            : prevQuestion
      )
    );
  }

  function moveSectionDown() {
    setQuestions((prevQuestions) =>
      prevQuestions.map((prevQuestion, i) =>
        i === index + 1
          ? question
          : i === index
            ? prevQuestions[index + 1]
            : prevQuestion
      )
    );
  }

  function deleteQuestion() {
    setQuestions((prevSections) => prevSections.filter((_, i) => i !== index));
  }

  function handleQuestionChange(e) {
    setQuestions((prevQuestions) =>
      prevQuestions.map((prevQuestion, i) =>
        i === index
          ? { ...prevQuestion, header_question: e.target.value }
          : prevQuestion
      )
    );
  }

  function handleHelperTextChange(value) {
    setQuestions((prevQuestions) =>
      prevQuestions.map((prevQuestion, i) =>
        i === index ? { ...prevQuestion, helper_text: value } : prevQuestion
      )
    );
  }

  return (
    <Flex wrap="wrap" gap="small">
      <Flex.Item size="100%">
        <TextInput
          id={`question-heading-section-${question.id}`}
          renderLabel={
            <Flex gap="small">
              <Flex.Item shouldGrow>
                {t("reflectionTemplates.question")}
              </Flex.Item>
              <Flex.Item>
                <IconButton
                  color="primary-inverse"
                  screenReaderLabel={t("reflectionTemplates.moveQuestionUp")}
                  size="small"
                  renderIcon={IconArrowOpenUpLine}
                  onClick={moveSectionUp}
                  disabled={index === 0}
                />
              </Flex.Item>
              <Flex.Item>
                <IconButton
                  color="primary-inverse"
                  screenReaderLabel={t("reflectionTemplates.moveQuestionDown")}
                  size="small"
                  renderIcon={IconArrowOpenDownLine}
                  onClick={moveSectionDown}
                  disabled={!!lastQuestion}
                />
              </Flex.Item>
              <Flex.Item>
                <IconButton
                  color="danger"
                  screenReaderLabel={t("reflectionTemplates.deleteQuestion")}
                  size="small"
                  renderIcon={IconTrashLine}
                  onClick={deleteQuestion}
                />
              </Flex.Item>
            </Flex>
          }
          defaultValue={question.header_question}
          onBlur={handleQuestionChange}
        />
      </Flex.Item>
      <Flex.Item size="100%">
        <CustomRTE
          id={`helper-text-${question.id}`}
          label={
            <Text weight="bold">
              {t("reflectionTemplates.additionalInstructions")}
              <span style={{ color: "#394B58" }}>
                <Text fontStyle="italic"> ({t("form.optional")})</Text>
              </span>
            </Text>
          }
          defaultValue={defaultHelperText.current}
          onChange={handleHelperTextChange}
        />
      </Flex.Item>
    </Flex>
  );
};

export default TemplateQuestionCard;
